import { useCallback, useEffect, useState } from 'react';

const useReportHeight = () => {
  const [reportHeight, setReportHeight] = useState(800); // Default height

  const calculateReportHeight = useCallback(() => {
    const screenHeight = window.innerHeight;
    const screenWidth = window.innerWidth;
    const baseHeight = screenWidth <= 768 ? 600 : 800;
    
    const minHeight = screenWidth <= 768 ? 500 : (screenWidth > 1920 ? 900 : 800);
    const maxHeight = screenWidth <= 768 ? 800 : (screenWidth > 1920 ? 1400 : 1200);

    let calculatedHeight = (screenHeight / 900) * baseHeight;
    
    if (screenWidth <= 768) {
      calculatedHeight *= 0.8;
    } else if (screenWidth <= 1024) {
      calculatedHeight *= 0.9;
    } else if (screenWidth > 2560) {
      calculatedHeight *= 1.2;
    }

    return Math.round(Math.max(minHeight, Math.min(maxHeight, calculatedHeight)));
  }, []);

  useEffect(() => {
    // Calculate initial height
    setReportHeight(calculateReportHeight());

    // Add window resize listener
    const handleResize = () => {
      setReportHeight(calculateReportHeight());
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [calculateReportHeight]);

  return reportHeight;
};

export default useReportHeight;